import { get, post, put, del } from '../lib/apiClient';

/** GET /organizations/mine */
export const getMyOrgs = () => get('/organizations/mine');

/** GET /organizations/{orgId} */
export const getOrg = (orgId) => get(`/organizations/${encodeURIComponent(orgId)}`);

/** GET /organizations?limit=&cursor=&status= */
export const listOrganizations = (query) => get('/organizations', { query });

/** POST /organizations - platform-admin or self-service */
export const createOrganization = (data) => post('/organizations', data);

/** PUT /organizations/{orgId} */
export const updateOrganization = (orgId, data) =>
  put(`/organizations/${encodeURIComponent(orgId)}`, data);

/** DELETE /organizations/{orgId} */
export const deleteOrganization = (orgId) =>
  del(`/organizations/${encodeURIComponent(orgId)}`);

/** GET /organizations/{orgId}/members?limit=&cursor= */
export const listMembers = (orgId, query) =>
  get(`/organizations/${encodeURIComponent(orgId)}/members`, { query });

/** POST /organizations/{orgId}/members */
export const addMember = (orgId, userId, role) =>
  post(`/organizations/${encodeURIComponent(orgId)}/members`, { userId, role });

/** DELETE /organizations/{orgId}/members/{userId} */
export const removeMember = (orgId, userId) =>
  del(`/organizations/${encodeURIComponent(orgId)}/members/${encodeURIComponent(userId)}`);

/** PUT /organizations/{orgId}/members/{userId}/role */
export const updateMemberRole = (orgId, userId, role) =>
  put(
    `/organizations/${encodeURIComponent(orgId)}/members/${encodeURIComponent(userId)}/role`,
    { role }
  );

/** POST /organizations/{orgId}/invites */
export const inviteMember = (orgId, email, role = 'member') =>
  post(`/organizations/${encodeURIComponent(orgId)}/invites`, { email, role });

/** POST /organizations/{orgId}/invites/accept */
export const acceptInvite = (orgId, token) =>
  post(`/organizations/${encodeURIComponent(orgId)}/invites/accept`, { token });
